import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/fatwa/$fatwaId")({
  component: React.lazy(() =>
    import("@/pages/fatawa/FatwaDetailPage").then((mod) => ({
      default: mod.default,
    })),
  ),
});
